import React, { useEffect, useState } from "react";
import { apiGetCustomers } from "../../api";

const AdminCustomers = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    apiGetCustomers().then(setList).catch(() => setList([]));
  }, []);

  return (
    <div>
      <h1 className="font-serif text-3xl text-neutral-900 mb-6">Customers ({list.length})</h1>
      <div className="bg-white rounded-sm border border-neutral-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-neutral-500 bg-neutral-50 border-b border-neutral-200">
              <th className="py-3 px-4 font-medium">Name</th>
              <th className="py-3 px-4 font-medium">Email</th>
              <th className="py-3 px-4 font-medium">Phone</th>
              <th className="py-3 px-4 font-medium">Orders</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr><td colSpan={4} className="py-8 text-center text-neutral-500">No registered customers yet.</td></tr>
            ) : list.map((c) => (
              <tr key={c.id} className="border-b border-neutral-100 hover:bg-neutral-50">
                <td className="py-3 px-4 font-medium text-neutral-800">{c.name}</td>
                <td className="py-3 px-4 text-neutral-600">{c.email}</td>
                <td className="py-3 px-4 text-neutral-600">{c.phone || "—"}</td>
                <td className="py-3 px-4">{c.orderCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCustomers;
